import { C as Cart } from './cart-DZS7CGyq.js';
import { P as PubSub } from './pubsub-COBwjfLh.js';
import { p as parseHTML } from './parseHTML-Om2c1Ayj.js';
import './uniq-BDEfcc0N.js';
import './notyf-DIw0RvBj.js';

class CartDrawer extends HTMLElement {
  #unsubscribers = [];

  static {
    Cart.sections.push('fetch-cart-drawer');
  }

  connectedCallback() {
    this.#unsubscribers.push(
      PubSub.subscribe('cart:add', (payload) => this.#renderAdd(payload)),
      ...['cart:update', 'cart:change', 'cart:clear'].map((event) =>
        PubSub.subscribe(event, ({ sections }) => this.#renderIncentiveBanner(sections))
      )
    );
  }

  disconnectedCallback() {
    this.#unsubscribers.forEach((unsubscribe) => unsubscribe());
  }

  /**
   * Refresh incentive banner + newly added line item when item is added to cart.
   * @param {object} payload - Cart add event payload.
   */
  #renderAdd(payload) {
    this.#renderIncentiveBanner(payload?.sections);
    if (payload?.source === 'algolia-recommend-mini-cart') return;
    this.#renderNewlyAdded(payload?.items, payload?.sections);
  }

  /**
   * Swap in the line item that was just added, matched by its cart line key.
   * Skip gift-with-purchase items, as they are never relevant here.
   * @param {object[]} items - The items that were just added to the cart.
   * @param {Object} sections - The rendered sections returned alongside the cart response.
   */
  #renderNewlyAdded(items, sections) {
    const item = items.find((item) => !item.properties._gwp);
    const current = this.querySelector('[data-cart-drawer-newly-added]');
    if (!item || !current || !sections) return;

    const html = parseHTML(sections['fetch-cart-drawer']);
    const target = html.querySelector(`[data-line-item-key="${item.key}"]`);
    if (!target) return;

    target.setAttribute('data-cart-drawer-newly-added', '');
    current.replaceWith(target);
  }

  /**
   * Update the incentive banner, happens on multiple cart events.
   * @param {Object} sections - The rendered sections returned alongside the cart response.
   */
  #renderIncentiveBanner(sections) {
    const current = this.querySelector('[data-cart-drawer-incentive-banner]');
    if (!current || !sections) return;

    const html = parseHTML(sections['fetch-cart-drawer']);
    const target = html.querySelector('[data-cart-drawer-incentive-banner]');
    if (!target) return;

    current.replaceWith(target);
  }
}

customElements.define('cart-drawer', CartDrawer);
